<template>
  <o-section
    :title="label || schema.verbose_name"
    not-closable
    :level="level + 1"
    body-classes="p-0"
  >
    <o-item-editable-table
      v-model="items"
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
      @change="changed"
    >
      <template slot="o-headers">
        <th v-if="canSee(schema, 'button_text')">
          {{ schema.fields.button_text.label }}
        </th>
        <th v-if="canSee(schema, 'style')">{{ schema.fields.style.label }}</th>
        <th v-if="canSee(schema, 'url')">{{ schema.fields.url.label }}</th>
      </template>
      <template #o-body="{ item, index }">
        <td v-if="canSee(schema, 'button_text')">
          <o-widget-wrapper
            :schema="schema"
            name="button_text"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-text-field
              v-model="items[index].button_text"
              :form-state="formState"
              name="button_text"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.button_text"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'style')">
          <o-widget-wrapper
            :schema="schema"
            name="style"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-select
              v-model="items[index].style"
              text-field="description"
              :items="styles"
              :form-state="formState"
              name="style"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              v-bind="schema.fields.style"
              nolabel
            ></o-select>
            <!-- <o-text-field
              v-model="items[index].style"
              :form-state="formState"
              name="style"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.style"
            ></o-text-field> -->
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'url')">
          <o-widget-wrapper
            :schema="schema"
            name="url"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-text-field
              v-model="items[index].url"
              :form-state="formState"
              name="url"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.url"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import schema from "../../schema/index.js";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify.js";
import { CreateDefaultItem } from "../../../vue-ocom/schema/schema_utils.js";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../vue-ocom/mixins";
import OItemEditableTable from "../../../vue-ocom/components/table/OItemEditableTable.vue";
import OSection from "../../../vue-ocom/components/layout/OSection.vue";

export default {
  name: "NotificationButtonFormTable",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("NotificationButton"),
    CreateCodeTableFetchMixin([]),
  ],
  components: { OItemEditableTable, OSection },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.NotificationButton,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.NotificationButton),
      styles: [
        { id: "primary", description: "Blue button" },
        { id: "secondary", description: "Gray button" },
        { id: "success", description: "Green button" },
        { id: "danger", description: "Red button" },
        { id: "warning", description: "Yellow button" },
        { id: "info", description: "Orange button" },
        { id: "light", description: "White button" },
        { id: "dark", description: "Black button" },
      ],
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {},
  created() {
    // this.loadCodeTables()
  },
};
</script>
